import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

/**
 * Used as the wildcard ('**') route component.
 *
 * When B2C redirects back to the app (redirectUri: origin → '/'), the URL
 * contains MSAL callback params (code=, state=, error=). In that case we
 * render nothing and let MsalRedirectComponent (bootstrapped in app.module.ts)
 * process the auth code and navigate to redirectStartPage.
 *
 * For any other unmatched URL (genuine 404 / direct navigation) we redirect
 * to the /login landing page as before.
 */
@Component({
  selector: 'laps-auth-callback',
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class AuthCallbackComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    const search = window.location.search;
    const hash = window.location.hash;
    const isMsalCallback =
      search.includes('code=') ||
      search.includes('error=') ||
      search.includes('state=') ||
      hash.includes('code=') ||
      hash.includes('error=');

    if (!isMsalCallback) {
      this.router.navigate(['/login']);
    }
    // If it IS an MSAL callback: render nothing.
    // MsalRedirectComponent handles the token exchange and navigates to /home.
  }
}
